import RichText from './RichText';

export default RichText;


// WEBPACK FOOTER //
// ./src/partials/modules/RichText/index.js